import { createSlice } from "@reduxjs/toolkit"
import { Section } from "./constants/sections.type"

export interface pendienteSupervisionState {
    drawerSelectedSection: Section
    drawerSelectedInitialSection: Section | null
}

const initialState: pendienteSupervisionState = {
    drawerSelectedSection: "home",
    drawerSelectedInitialSection: null,
}

export const pendienteSupervisionSlice = createSlice({
    name: "pendienteSupervision",
    initialState,
    reducers: {
        selectPendienteSupervisionSection: (state, action: {payload:  Section, type: string}) => {
            state.drawerSelectedSection = action.payload
        },
        selectPendienteSupervisionInitialSection: (state, action: {payload: Section | null, type: string}) => {
            state.drawerSelectedInitialSection = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { selectPendienteSupervisionSection, selectPendienteSupervisionInitialSection } = pendienteSupervisionSlice.actions

export default pendienteSupervisionSlice.reducer
